(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tgw-card-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT_SELECTOR = '[data-tgw-card-carousel]';
  const controllers = new WeakMap();

  class TGWCardCarousel {
    constructor(root) {
      this.root = root;
      this.track = root.querySelector('[data-track]');
      this.slides = Array.from(root.querySelectorAll('[data-slide]'));
      this.prevButton = root.querySelector('.tgw-card-carousel__arrow--prev');
      this.nextButton = root.querySelector('.tgw-card-carousel__arrow--next');
      this.dots = Array.from(root.querySelectorAll('[data-dot]'));
      this.loop = root.dataset.loop === 'true';
      this.isAnimating = false;
      this.animationFrame = null;
      this.scrollTimer = null;

      this.zoomTriggers = Array.from(root.querySelectorAll('[data-zoom-trigger]'));
      this.lightbox = root.querySelector('[data-lightbox]');
      this.lightboxImage = root.querySelector('[data-lightbox-image]');
      this.lightboxFrame = root.querySelector('[data-lightbox-frame]');
      this.lightboxCounter = root.querySelector('[data-lightbox-counter]');
      this.zoomItems = this.zoomTriggers
        .map((trigger) => ({
          src: trigger.dataset.zoomSrc,
          alt: trigger.dataset.zoomAlt || '',
          index: Number(trigger.dataset.zoomIndex || 0)
        }))
        .filter((item) => item.src);

      this.activeZoomIndex = 0;
      this.zoomImageCache = new Map();
      this.lightboxWheelLocked = false;
      this.lightboxPointerStart = null;

      this.onClick = this.handleClick.bind(this);
      this.onScroll = this.handleScroll.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);
      this.onPointerDown = this.handlePointerDown.bind(this);
      this.onPointerUp = this.handlePointerUp.bind(this);
      this.onPointerCancel = this.handlePointerCancel.bind(this);
      this.onLightboxWheel = this.handleLightboxWheel.bind(this);
      this.onFallbackResize = this.updateStaticState.bind(this);
    }

    init() {
      if (!this.track || !this.slides.length) return;

      this.root.addEventListener('click', this.onClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.lightboxFrame?.addEventListener('pointerdown', this.onPointerDown);
      this.lightboxFrame?.addEventListener('pointerup', this.onPointerUp);
      this.lightboxFrame?.addEventListener('pointercancel', this.onPointerCancel);
      this.lightbox?.addEventListener('wheel', this.onLightboxWheel, { passive: false });

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.updateStaticState());
        this.resizeObserver.observe(this.track);
      } else {
        window.addEventListener('resize', this.onFallbackResize, { passive: true });
      }

      requestAnimationFrame(() => {
        this.updateStaticState();
        this.updateDots();
      });
    }

    destroy() {
      this.closeLightbox();
      this.root.removeEventListener('click', this.onClick);
      this.track?.removeEventListener('scroll', this.onScroll);
      this.lightboxFrame?.removeEventListener('pointerdown', this.onPointerDown);
      this.lightboxFrame?.removeEventListener('pointerup', this.onPointerUp);
      this.lightboxFrame?.removeEventListener('pointercancel', this.onPointerCancel);
      this.lightbox?.removeEventListener('wheel', this.onLightboxWheel);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.onFallbackResize);
      window.clearTimeout(this.scrollTimer);
      if (this.animationFrame) cancelAnimationFrame(this.animationFrame);
    }

    handleClick(event) {
      const zoomTrigger = event.target.closest('[data-zoom-trigger]');
      if (zoomTrigger && this.root.contains(zoomTrigger)) {
        event.preventDefault();
        event.stopPropagation();
        this.openLightbox(Number(zoomTrigger.dataset.zoomIndex || 0));
        return;
      }

      if (event.target.closest('.tgw-card-carousel__arrow--prev')) {
        this.goPrevious();
        return;
      }

      if (event.target.closest('.tgw-card-carousel__arrow--next')) {
        this.goNext();
        return;
      }

      const dot = event.target.closest('[data-dot]');
      if (dot) {
        this.goToSlide(Number(dot.dataset.dot || 0));
        return;
      }

      if (event.target.closest('[data-lightbox-close]')) {
        this.closeLightbox();
        return;
      }

      if (event.target.closest('[data-lightbox-prev]')) {
        this.showPreviousLightboxImage();
        return;
      }

      if (event.target.closest('[data-lightbox-next]')) {
        this.showNextLightboxImage();
        return;
      }

      if (event.target === this.lightbox) {
        this.closeLightbox();
      }
    }

    getDuration() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
      const raw = getComputedStyle(this.root).getPropertyValue('--tgw-cc-arrow-duration').trim();
      return parseInt(raw, 10) || 350;
    }

    getMaxScroll() {
      return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
    }

    getStep() {
      if (!this.slides.length) return this.track.clientWidth;
      const styles = window.getComputedStyle(this.track);
      const gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      return this.slides[0].getBoundingClientRect().width + gap;
    }

    isAtStart() {
      return this.track.scrollLeft <= 2;
    }

    isAtEnd() {
      return this.track.scrollLeft >= this.getMaxScroll() - 2;
    }

    goPrevious() {
      if (this.isAnimating) return;
      const maxScroll = this.getMaxScroll();
      if (maxScroll <= 2) return;

      if (this.loop && this.isAtStart()) {
        this.track.scrollTo({ left: maxScroll, behavior: 'auto' });
        this.updateDots();
        return;
      }

      this.animateTo(this.track.scrollLeft - this.getStep());
    }

    goNext() {
      if (this.isAnimating) return;
      const maxScroll = this.getMaxScroll();
      if (maxScroll <= 2) return;

      if (this.loop && this.isAtEnd()) {
        this.track.scrollTo({ left: 0, behavior: 'auto' });
        this.updateDots();
        return;
      }

      this.animateTo(this.track.scrollLeft + this.getStep());
    }

    goToSlide(index) {
      const slide = this.slides[index];
      if (!slide || this.isAnimating) return;
      this.animateTo(slide.offsetLeft - this.track.offsetLeft);
    }

    animateTo(targetLeft) {
      const maxScroll = this.getMaxScroll();
      const startLeft = this.track.scrollLeft;
      const endLeft = Math.max(0, Math.min(targetLeft, maxScroll));
      const distance = endLeft - startLeft;
      const duration = this.getDuration();

      if (Math.abs(distance) <= 1) return;
      if (duration === 0) {
        this.track.scrollLeft = endLeft;
        this.updateDots();
        return;
      }

      const startTime = performance.now();
      const easeOutCubic = (t) => 1 - Math.pow(1 - t, 3);
      this.isAnimating = true;

      const tick = (now) => {
        const progress = Math.min(1, (now - startTime) / duration);
        this.track.scrollLeft = startLeft + distance * easeOutCubic(progress);

        if (progress < 1) {
          this.animationFrame = requestAnimationFrame(tick);
        } else {
          this.animationFrame = null;
          this.isAnimating = false;
          this.updateDots();
        }
      };

      this.animationFrame = requestAnimationFrame(tick);
    }

    openLightbox(index) {
      if (!this.lightbox || !this.lightboxImage || !this.zoomItems.length) return;

      const matchedIndex = this.zoomItems.findIndex((item) => item.index === index);
      this.activeZoomIndex = matchedIndex >= 0 ? matchedIndex : 0;
      this.lightbox.hidden = false;
      this.lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.addEventListener('keydown', this.onKeydown);
      this.updateLightboxImage();
      this.root.querySelector('[data-lightbox-close]')?.focus({ preventScroll: true });
    }

    closeLightbox() {
      if (!this.lightbox || this.lightbox.hidden) return;
      this.lightbox.hidden = true;
      this.lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', this.onKeydown);
      this.lightboxPointerStart = null;
    }

    preloadImage(src) {
      if (!src) return null;
      if (this.zoomImageCache.has(src)) return this.zoomImageCache.get(src);

      const image = new Image();
      image.decoding = 'async';
      image.src = src;
      this.zoomImageCache.set(src, image);
      return image;
    }

    updateLightboxImage() {
      const item = this.zoomItems[this.activeZoomIndex];
      if (!item || !this.lightboxImage) return;

      if (this.lightboxCounter) {
        this.lightboxCounter.textContent = `${this.activeZoomIndex + 1} / ${this.zoomItems.length}`;
      }

      const preload = this.preloadImage(item.src);
      this.lightboxImage.classList.add('is-loading');
      this.lightboxImage.alt = item.alt;

      const applyImage = () => {
        if (this.zoomItems[this.activeZoomIndex]?.src !== item.src) return;
        this.lightboxImage.src = item.src;
        this.lightboxImage.classList.remove('is-loading');
      };

      if (preload?.complete && preload.naturalWidth > 0) {
        applyImage();
      } else {
        preload?.addEventListener('load', applyImage, { once: true });
        preload?.addEventListener('error', applyImage, { once: true });
      }

      this.preloadNearbyImages();
    }

    preloadNearbyImages() {
      if (this.zoomItems.length < 2) return;
      const previousIndex = (this.activeZoomIndex - 1 + this.zoomItems.length) % this.zoomItems.length;
      const nextIndex = (this.activeZoomIndex + 1) % this.zoomItems.length;
      this.preloadImage(this.zoomItems[previousIndex]?.src);
      this.preloadImage(this.zoomItems[nextIndex]?.src);
    }

    showPreviousLightboxImage() {
      if (!this.zoomItems.length) return;
      this.activeZoomIndex = (this.activeZoomIndex - 1 + this.zoomItems.length) % this.zoomItems.length;
      this.updateLightboxImage();
    }

    showNextLightboxImage() {
      if (!this.zoomItems.length) return;
      this.activeZoomIndex = (this.activeZoomIndex + 1) % this.zoomItems.length;
      this.updateLightboxImage();
    }

    isLightboxOpen() {
      return this.lightbox && !this.lightbox.hidden;
    }

    handlePointerDown(event) {
      if (!this.isLightboxOpen() || event.target.closest('button')) return;
      this.lightboxPointerStart = {
        x: event.clientX,
        y: event.clientY,
        time: Date.now(),
        pointerId: event.pointerId
      };
      this.lightboxFrame?.setPointerCapture?.(event.pointerId);
    }

    handlePointerUp(event) {
      if (!this.lightboxPointerStart || !this.isLightboxOpen()) return;
      const deltaX = event.clientX - this.lightboxPointerStart.x;
      const deltaY = event.clientY - this.lightboxPointerStart.y;
      const elapsed = Date.now() - this.lightboxPointerStart.time;
      this.lightboxPointerStart = null;
      this.handleSwipeDelta(deltaX, deltaY, elapsed);
    }

    handlePointerCancel() {
      this.lightboxPointerStart = null;
    }

    handleSwipeDelta(deltaX, deltaY, elapsed) {
      if (elapsed > 1000 || Math.abs(deltaX) < 45 || Math.abs(deltaX) < Math.abs(deltaY) * 1.1) return;
      deltaX < 0 ? this.showNextLightboxImage() : this.showPreviousLightboxImage();
    }

    handleLightboxWheel(event) {
      if (!this.isLightboxOpen()) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY) || Math.abs(event.deltaX) < 10) return;

      event.preventDefault();
      if (this.lightboxWheelLocked) return;
      this.lightboxWheelLocked = true;
      event.deltaX > 0 ? this.showNextLightboxImage() : this.showPreviousLightboxImage();

      window.setTimeout(() => {
        this.lightboxWheelLocked = false;
      }, 420);
    }

    handleKeydown(event) {
      if (!this.isLightboxOpen()) return;
      if (event.key === 'Escape') this.closeLightbox();
      if (event.key === 'ArrowLeft') this.showPreviousLightboxImage();
      if (event.key === 'ArrowRight') this.showNextLightboxImage();
    }

    handleScroll() {
      window.clearTimeout(this.scrollTimer);
      this.scrollTimer = window.setTimeout(() => this.updateDots(), 80);
    }

    updateDots() {
      if (!this.dots.length || !this.slides.length) return;
      const step = this.getStep();
      const index = Math.min(
        this.slides.length - 1,
        Math.max(0, Math.round(this.track.scrollLeft / step))
      );
      this.dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    }

    updateStaticState() {
      const hasScroll = this.getMaxScroll() > 2;
      this.root.classList.toggle('is-static', !hasScroll);
      this.updateDots();
    }
  }

  const collectRoots = (scope) => {
    const roots = [];
    if (scope?.matches?.(ROOT_SELECTOR)) roots.push(scope);
    if (scope?.querySelectorAll) roots.push(...scope.querySelectorAll(ROOT_SELECTOR));
    return [...new Set(roots)];
  };

  const init = (scope = document) => {
    collectRoots(scope).forEach((root) => {
      if (controllers.has(root)) return;
      const controller = new TGWCardCarousel(root);
      controllers.set(root, controller);
      controller.init();
    });
  };

  const destroy = (scope) => {
    collectRoots(scope).forEach((root) => {
      controllers.get(root)?.destroy();
      controllers.delete(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => destroy(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
